/* eslint-disable no-shadow */

// initial state
const state = {
  tableOptions: {}
};

// getters - all receive state as first argument
const getters = {
  getLoadTestTableOptions: (state) => state.tableOptions
};

// actions
const actions = {};

// mutations
const mutations = {
  setLoadTestTableOptions(state, options) {
    state.tableOptions = options;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
